import FileInfoUtil from './FileInfoUtil';
import _ from 'lodash';

window.onDrop = (e, options) => {
  if (e.dataTransfer.items && window.DataTransferItem && window.DataTransferItem.prototype.webkitGetAsEntry) {
    // Newer APIs allow DnD of folders. Safari still doesn't support this as of Sept 2017.
    return handleItems(e.dataTransfer.items, options);
  } else if (e.dataTransfer.files) {
    return handleFiles(e.dataTransfer.files, options);
  }
};

const handleItems = (items, options) => new Promise((resolve, reject) => {
  var files = [];

  // When an async operation start increment the counter, when it finishes decrement
  // when counter is 0 it means that we have red all the items recursively to the very bottom and we need to handle the result
  var counter = 0;

  for (var item of items) {
    var entry = item.webkitGetAsEntry();

    if (entry.isDirectory) scanDirectory(entry);
    else {
      counter++;
      entry.file(handleAsyncFile);
    }
  }

  function scanDirectory(entry) {
    var reader = entry.createReader();
    counter++;
    reader.readEntries(function(entries) {
      counter--;

      for (var entry of entries) {
        if (entry.isDirectory) scanDirectory(entry);
        else {
          counter++;
          entry.file(handleAsyncFile);
        }
      }

      if (counter == 0) window.handleFiles(files, options).then(resolve).catch(reject);
    });
  }

  function handleAsyncFile(file) {
    counter--;
    let fileToIgnore = _.indexOf(FileInfoUtil.ignoreFileNames, file.name) > -1;

    // if (!fileToIgnore) {
    //   const ext = FileInfoUtil.getFileExtension(file.name);
    //   fileToIgnore = ext.length > 0 && _.indexOf(FileInfoUtil.ignoreFileTypes, ext) > -1;
    // }

    if (!fileToIgnore) {
      files.push(file);
    }

    if (counter == 0) window.handleFiles(files, options).then(resolve).catch(reject);
  }
});

function handleFiles(files, options) {
  const filesOnly = [...files].filter(f => f.type !== '');
  return window.handleFiles(filesOnly, options);
}
